// React
import React from "react";

// Libs
import { useTranslation } from "react-i18next";

// UI
import { Button } from "../spocketUI";

// Assets
import aliscraperLogo from "../images/aliscraper-logo.svg";
import chromeWebStoreBadge from "../images/chrome-web-store-badge.svg";
import aliscraperIllustration from "../images/aliscraper-illustration.png";

import {
  PageContainer,
  Logo,
  Title,
  Subtitle,
  Features,
  Feature,
  Footer,
  ChromeLogo,
  InformationSection,
  Illustration
} from "./AliscraperStyle";

const Aliscraper = () => {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <InformationSection>
        <Logo>
          <img src={aliscraperLogo} alt="Aliscraper Logo" />
          <span>Beta</span>
        </Logo>
        <Title>{t("Aliscraper.Title")}</Title>
        <Subtitle>{t("Aliscraper.Subtitle")}</Subtitle>
        <Features>
        
          <Feature>{t("Aliscraper.Features.Feature1")}</Feature>
          <Feature>{t("Aliscraper.Features.Feature2")}</Feature>
          <Feature>{t("Aliscraper.Features.Feature3")}</Feature>
        </Features>
        <Footer>
          <Button
            as="a"
            variant="primaryBig"
            href="https://chrome.google.com/webstore/detail/aliscraper/hdlajobndamjlloioebnannnlbopndee"
            target="_blank"
          >
            {t("Aliscraper.Button")}
          </Button>
          <ChromeLogo>
            <img src={chromeWebStoreBadge} alt="" />
            {t("Aliscraper.Chrome")}
          </ChromeLogo>
        </Footer>
      </InformationSection>
      <Illustration>
        <img src={aliscraperIllustration} alt="Aliscraper Illustration" />
      </Illustration>
    </PageContainer>
  );
};

export default Aliscraper;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/Aliscraper.js